import React  from "react";
import Grid from '@material-ui/core/Grid';

export const Text = ({children, container, className}) => {
    return (
        <Grid container {...container}>
            <p className={className}>{children}</p>
        </Grid>
    )
};

